import { Box, ListItem, ListItemButton, Stack } from "@mui/material";
import Text from "src/components/Displays/Text";
import { ChevronRight2 } from "src/assets";

interface EvseListItemProps {
  itemText: string;
  itemTextValue?: string;
  showArrowIcon?: boolean;
  handleItemClick?: () => void;
  /** Inset separator rendered inside this list item, after the row. */
  divider?: boolean;
}

const EvseListItem = ({
  itemText,
  itemTextValue,
  handleItemClick,
  showArrowIcon = true,
  divider = false,
}: EvseListItemProps) => {
  const content = (
    <Stack
      sx={{
        justifyContent: "space-between",
        flexDirection: "row",
        alignItems: "center",
        width: "100%",
        py: 2,
      }}
    >
      <Text
        text={itemText}
        sx={(theme) => ({
          fontSize: "14px",
          fontWeight: "400",
          lineHeight: "20px",
          fontFamily: "Inter",
          color: theme.palette.black[50],
        })}
      />

      {showArrowIcon && (
        <Stack alignItems={"end"}>
          <ChevronRight2 />
        </Stack>
      )}

      {itemTextValue && (
        <Text
          text={itemTextValue}
          sx={(theme) => ({
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "20px",
            fontFamily: "Inter",
            color: theme.palette.black[50],
          })}
        />
      )}
    </Stack>
  );

  return (
    <ListItem
      disablePadding
      disableGutters
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
      }}
    >
      {handleItemClick ? (
        <ListItemButton onClick={handleItemClick}>{content}</ListItemButton>
      ) : (
        <Box sx={{ width: "100%", padding: "8px 16px" }}>{content}</Box>
      )}
      {divider && (
        <Box
          aria-hidden="true"
          sx={{
            borderBottom: "1px solid",
            borderColor: "divider",
            mx: "16px",
          }}
        />
      )}
    </ListItem>
  );
};

export default EvseListItem;
